<template>
  <div class="accordion" data-track-as="accordion">
    <slot></slot>
  </div>
</template>

<script>
import SanitasCollapsible from './SanitasCollapsible'

export default {
  name: 'SanitasAccordion',
  components: {
    /* eslint-disable-next-line */
    SanitasCollapsible,
  },
}
</script>

<style lang="postcss">
.accordion {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: auto;
  padding: 0;
  margin-bottom: var(--spacing-8);

  @media (min-width: 580px) {
    border-radius: var(--border-radius);
  }
}
</style>
